import { Box, Paper, Typography } from '@mui/material';
import React from 'react';



const Mechanics = ({ mechanicsContent, tabHeight }) => {



    return (
        <Box
            sx={{
                height: `calc(100vh - ${tabHeight})`,
                paddingTop: '5px',
                boxSizing: 'border-box',
                overflowY: 'auto',
                p: 1
            }}
        >

            {mechanicsContent.length > 0 ? (
                mechanicsContent.map((mechanic, index) => (
                    <Paper elevation={3} sx={{ padding: 2, marginBottom: 2 }}>
                        <Typography key={index}>{mechanic}</Typography>
                    </Paper>
                ))
            ) : (
                <Paper elevation={3} sx={{ padding: 2, marginBottom: 2 }}>
                    <Typography>No new mechanics to display.</Typography>
                </Paper>
            )}
        </Box >
    );
};

export default Mechanics;
